import { FC } from "react";
import { AppPartType } from "../../../types";
import styled from "styled-components";
import { AiOutlineCheck } from "react-icons/ai";

type PropsType = {
  appPart: AppPartType;
};

const SelectList = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 7px;
  .select-option {
    line-height: 24px;
    color: #000;
    display: flex;
    align-items: center;
    svg {
      margin-right: 3px;
    }
    &.checked {
      color: #83b1e7;
    }
  }
`;

const Multichoice: FC<PropsType> = ({ appPart }) => {
  const {
    item_config_data: { options },
  } = appPart;

  const listOptions =
    Array.isArray(options) && options?.length > 0
      ? options
      : [
          { text: "サンプル1", value: "サンプル1" },
          { text: "サンプル2", value: "サンプル2" },
          { text: "サンプル3", value: "サンプル3" },
          { text: "サンプル4", value: "サンプル4" },
        ];

  return (
    <SelectList>
      {listOptions?.map((o) => (
        <div
          className={`select-option${o.default_checked ? " checked" : ""}`}
          key={o.text}
        >
          {o.default_checked && <AiOutlineCheck />}
          {o.text}
        </div>
      ))}
    </SelectList>
  );
};

export default Multichoice;
